import { useState, memo, useMemo } from 'react';
import {
  BIO_SUITABLE_TEXT_LENGTH,
  BIO_SUITABLE_TEXT_MAX_LENGTH,
  BIO_SUITABLE_TEXT_MAX_WIDTH,
  SUITABLE_TEXT_MAX_LINE,
} from '../../../../constant/user-setting-modal-resources';
import {
  checkStringNeedToBeSeeMore,
  numberOfNewLine,
  renderNewStringWithNewLine,
} from '../../../../helpers/stringHelpers';
import { IBioProps } from '../../../../interfaces/profile.interface';

const BioComponent: React.FC<IBioProps> = ({ data }) => {
  const [seeMore, setSeeMore] = useState<boolean>(false);

  const { bio }: { bio: string } = useMemo(() => data, [data]);

  return (
    <div>
      <span
        className={`text-[14px] leading-[24px] flex-1 break-words ${
          bio ? '' : 'text-gray-500'
        }`}
      >
        {!seeMore &&
        checkStringNeedToBeSeeMore(
          bio,
          BIO_SUITABLE_TEXT_MAX_LENGTH,
          BIO_SUITABLE_TEXT_MAX_WIDTH
        )
          ? `${
              numberOfNewLine(bio) === 1
                ? bio?.substring(0, BIO_SUITABLE_TEXT_LENGTH)
                : renderNewStringWithNewLine(
                    bio,
                    SUITABLE_TEXT_MAX_LINE,
                    BIO_SUITABLE_TEXT_MAX_WIDTH
                  )
            }`
          : `${bio || 'Chưa cập nhật'}`}
      </span>
      <div
        className="text-primary hover:underline inline-block text-sm text-right cursor-pointer"
        onClick={() => {
          setSeeMore(true);
        }}
      >
        {!seeMore &&
        checkStringNeedToBeSeeMore(
          bio,
          BIO_SUITABLE_TEXT_MAX_LENGTH,
          BIO_SUITABLE_TEXT_MAX_WIDTH
        )
          ? '...xem thêm'
          : null}
      </div>
    </div>
  );
};

export default memo(BioComponent);
